import Avatar from '@ui/Avatar';
import ProgressBar from '@ui/ProgressBar';
import Typography from '@ui/Typography';
import { abbreviateNumber } from '@utils/stringHelpers';
import getSymbolFromCurrency from 'currency-symbol-map';
import { cx } from 'cva';
import React from 'react';
import useStore from '@/stores/store';
import PostType from '@/constants/postType.constants';
import useHasUserSession from '@/hooks/useHasUserSession';
import useCompanyConnectPopUpStore from '../store/companyConnectPopUpSlice';
import OrgType from '@/constants/orgType.constant';
import { sortBy, take } from 'lodash-es';

function ContributionProgress(props) {
  const { post, className } = props;
  const donors = post.renderProps.donations.allDonors || [];
  const totalDonors = donors.length;
  const latestDonors = take(sortBy(donors, 'createdOn'), 3);
  // const donatedAmount = post.totalDonations || post.renderProps.donations.total;
  const donatedAmount = post.renderProps.donations.total || post.totalDonations;
  const goalAmount = post.sourcePostData?.goalAmount || 0;
  const currency = post.renderProps.donations.currency;
  const symbol = getSymbolFromCurrency(currency) || '$';

  const hasUserSession = useHasUserSession();

  const showPostContributorDialog = useStore(
    (state) => state.postContributorDialog.showDialog,
  );

  const setShowCompanyConnectPopUp = useCompanyConnectPopUpStore(
    (state) => state.setOpen,
  );

  const handleShowAllContributors = () => {
    if (hasUserSession) {
      if (post) {
        showPostContributorDialog(post, PostType.CrowdFunding, 'contributors');
      }
    } else {
      if (
        [OrgType.Business, OrgType.ChangeMakers].includes(
          post.renderProps.company.orgType,
        )
      ) {
        setShowCompanyConnectPopUp(true, post.renderProps.company);
      }
    }
  };

  const renderDonors = () => {
    if (post.totalDonors > 0) {
      return (
        <Typography
          variant="hyperlink"
          className="hover:cursor-pointer"
          onClick={handleShowAllContributors}>
          {totalDonors} {totalDonors > 1 ? 'contributions' : 'contribution'}
        </Typography>
      );
    }
    return null;
  };

  // if (latestDonors.length === 0 && donatedAmount === 0) {
  //   return null;
  // }

  return (
    <div className="flex w-full flex-col items-start gap-2">
      <div className="flex w-full flex-1 flex-col items-start justify-start gap-2 lg:flex-row lg:items-center lg:gap-4">
        <div className="flex flex-1 items-center gap-4">
          <div className="flex items-center -space-x-4">
            {latestDonors.length > 0 &&
              latestDonors.map((donor, index) => (
                <div
                  key={index}
                  className={cx(
                    'relative inline',
                    `z-${(latestDonors.length - index) * 10}`,
                  )}>
                  <Avatar
                    key={donor.id}
                    profile="user"
                    src={donor.avatar}
                    alt={`${donor.firstName} ${donor.lastName}`}
                  />
                </div>
              ))}
          </div>
          <div>{renderDonors()}</div>
        </div>
        <div
          className={cx(
            'flex w-full items-center gap-4 rounded-lg bg-body-background px-4 py-1 lg:ml-auto lg:w-auto',
            className,
          )}>
          <div className="flex items-end">
            <Typography variant="h3" className="whitespace-nowrap">
              {symbol}
              {abbreviateNumber(donatedAmount)}
            </Typography>
            <Typography variant="body2" className="whitespace-nowrap">
              /{symbol}
              {abbreviateNumber(goalAmount)}
            </Typography>
          </div>
          <div className="w-36 flex-1">
            <ProgressBar
              value={donatedAmount}
              max={goalAmount}
              size="small"
              background="white"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContributionProgress;
